import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-polyglot';
import Logo from './Logo';
import './Footer.css';

function Footer(props) {
  return (
    <footer className="footer">
      <div className="footer__logo">
        <div className="footer__logo--mobile">
          <Logo type="icon" className="footer__logo-image" />
        </div>
        <div className="footer__logo--desktop">
          <Logo className="footer__logo-image" type="icon" />
        </div>
      </div>
      <p className="footer__legal-links">
        <NavLink className="text-link" exact to="/subpage/terms-of-service">
          Terms of Service
        </NavLink>{' '}
        <NavLink
          className="text-link"
          exact
          to="/subpage/privacy-and-confidentiality"
        >
          {props.t('nav.privacy')}
        </NavLink>
      </p>
      <p className="footer__note">{props.t('nav.copyright').replace('2019', new Date().getFullYear())}</p>
    </footer>
  );
}

// location prop is needed because of: https://github.com/ReactTraining/react-router/blob/master/packages/react-router/docs/guides/blocked-updates.md

Footer.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isAdmin: PropTypes.bool.isRequired,
  handleLogout: PropTypes.func.isRequired,
  onInviteClick: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line
  t: PropTypes.func.isRequired
};

export default translate()(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer.js